const ApiObject = {
    userLogin: {
        method: 'post',
        url: '/background/admin_login',
        description: '用户登录'
    },
    manageUserLogin: {
        method: 'post',
        url: '/manager/admin-login',
        description: '管理员登录'
    },
    getOrderList: {
        method: 'post',
        url: 'background/payment-list',
        description: '订单列表'
    },
    getVoucherList: {
        method: 'post',
        url: 'background/voucher-list',
        description: '代金券订单列表'
    },
    exportOrderList: {
        method: 'post',
        url: 'background/payment-ex',
        description: '导出订单列表'
    },
    exportUserList: {
        method: 'post',
        url: 'background/user-ex',
        description: '导出用户列表'
    },
    exportSearchList: {
        method: 'post',
        url: 'background/search-ex',
        description: '导出搜索记录列表'
    },
    exportFootprintList: {
        method: 'post',
        url: 'background/footprint-user-ex',
        description: '导出活跃列表用户'
    },
    getUserList: {
        method: 'post',
        url: 'background/user-list',
        description: '用户列表'
    },
    getSearchList: {
        method: 'post',
        url: 'background/search-list',
        description: '搜索列表'
    },
    getPrizeList: {
        method: 'post',
        url: 'background/draw-list',
        description: '抽奖记录'
    },
    getFoorPrintList: {
        method: 'post',
        url: 'background/footprint-user-list',
        description: '活跃用户列表'
    },
    getUserFoorPrintList: {
        method: 'post',
        url: 'background/footprint-list',
        description: '用户轨迹列表'
    },
    getDashboard: {
        method: 'post',
        url: 'background/dashboard',
        description: 'dashboard'
    },
    getManageList: {
        method: 'post',
        url: 'manager/role-list',
        description: '用户列表'
    },
    getPermissionList: {
        method: 'post',
        url: 'manager/permission-list',
        description: '用户权限列表'
    },
    createNewRole: {
        method: 'post',
        url: 'manager/role-new',
        description: '新建角色'
    },
    createManage: {
        method: 'post',
        url: 'manager/register',
        description: '新建管理员'
    },
    getBindList: {
        method: 'post',
        url: 'background/list-qudao-op',
        description: '渠道运营信息列表'
    },
    bindWeChat: {
        method: 'post',
        url: 'background/edit-qudao-op',
        description: '渠道绑定微信（新增编辑）'
    },
    deleteBindWeChat: {
        method: 'post',
        url: 'background/del-qudao-op',
        description: '渠道绑定微信（删除）'
    },
    getTotalData: {
        method: 'post',
        url: 'background/payment-statistics',
        description: '收入统计'
    },
    getProjectTotalData: {
        method: 'post',
        url: 'background/scenics_payment-statistics',
        description: '项目收入统计'
    },
    restartVideoTask: {
        method: 'post',
        url: 'background/restart_video_task',
        description: '重新合成视频'
    },

    // 新权限接口
    getAdministrators: {
        method: 'post',
        url: 'admin/get_administrators',
        description: '获取管理员列表'
    },
    getMenus: {
        method: 'post',
        url: 'admin/get_menus',
        description: '获取菜单权限列表'
    },
    getScenicInfo: {
        method: 'post',
        url: 'admin/get_scenic_info',
        description: '获取项目列表'
    },
    editScenic: {
        method: 'post',
        url: 'admin/edit_scenic',
        description: '编辑项目'
    },
    deleteScenic: {
        method: 'post',
        url: 'admin/delete_scenic',
        description: '删除项目'
    },
    editAdministrators: {
        method: 'post',
        url: 'admin/edit_administrators',
        description: '编辑/新建管理员'
    },
    deleteAdministrator: {
        method: 'post',
        url: 'admin/delete_administrator',
        description: '刪除管理员'
    },
    getServerStatus: {
        method: 'post',
        url: 'monitors/check_server_status',
        description: '服务器基础情况监控'
    },
    getSharingLogs: {
        method: 'post',
        url: 'background/get_sharing_logs',
        description: '获取分账日志'
    },
    getTaskSuccessRatioToday: {
        method: 'post',
        url: 'background/get_task_success_ratio_today',
        description: '搜索记录列表统计当天合成成功率'
    },
    getRefundList: {
        method: 'post',
        url: 'background/payment-refund-lst',
        description: '退款列表'
    },
    getCouponCode: {
        method: 'post',
        url: 'payment/voucher-new',
        description: '生成兑换码'
    },
    getScenicStatistics: {
        method: 'post',
        url: 'background/get_scenic_statistics',
        description: '获取财务统计'
    },
    getScenicStatisticsAccumulate: {
        method: 'post',
        url: 'background/get_scenic_statistics_accumulate',
        description: '获取财务统计2'
    },
    exprotScenicStatistics: {
        method: 'post',
        url: 'background/scenic_statistics-ex',
        description: '导出财务统计'
    },
    exprotScenicAnalysis: {
        method: 'post',
        url: 'background/scenic_analysis-ex',
        description: '导出行为分析'
    },
    newDressingTemplate: {
        method: 'post',
        url: 'ai_dressing/new_dressing_template',
        description: '新建换脸模板'
    },
    getDressingTemplates: {
        method: 'post',
        url: 'ai_dressing/get_dressing_template_lst',
        description: '获取换脸模板'
    },
    editDressingTemplate: {
        method: 'post',
        url: 'ai_dressing/edit_dressing_template',
        description: '编辑换脸模板'
    },
    deleteDressingTemplate: {
        method: 'post',
        url: 'ai_dressing/delete_dressing_template',
        description: '删除换脸模板'
    },
};


export default ApiObject;


// WEBPACK FOOTER //
// ./src/service/api.js